<template>
  <div class="md-layout">
    <!-- 模板 -->
    <div class="md-layout-item md-size-100 md-xsmall-size-100 mx-auto" style="margin-top: -30px;">
      <div style="box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);">
        <simple-wizard :start-index="startIndex" @update:startIndex="updateIndex">
          <template slot="header">
            <md-card class="md-card-only-title">
              <md-card-content>
                <add-button @click="table_addItem">{{$I18n("add")}}</add-button>
              </md-card-content>
            </md-card>
          </template>
          <wizard-tab >
            <template slot="label"> {{$I18n("acc_ser")}} </template>
            <md-table v-model="tableData">
              <md-table-row slot="md-table-row" slot-scope="{ item }" >
                <md-table-cell :md-label="$I18n('source_area_type')">{{ item.src_type_name }}</md-table-cell>
                <md-table-cell :md-label="$I18n('the_code')">{{ item.src_area }}</md-table-cell>
                <md-table-cell :md-label="$I18n('name')">{{ item.src_area_name }}</md-table-cell>
                <md-table-cell :md-label="$I18n('object_area_type')">{{ item.dest_type_name }}</md-table-cell>
                <md-table-cell :md-label="$I18n('the_code')">{{ item.dest_area }}</md-table-cell>
                <md-table-cell :md-label="$I18n('name')">{{ item.dest_area_name }}</md-table-cell>
                <md-table-cell :md-label="$I18n('state')">{{ item.state_name }}</md-table-cell>
                <md-table-cell :md-label="$I18n('remarks')">{{ item.remark }}</md-table-cell>
                <md-table-cell :md-label="$I18n('operate')"  class="button-box">
                  <md-button
                    @click.stop="table_editItem(item)"
                    class="md-just-icon md-round md-info"
                    ><md-icon>edit</md-icon></md-button
                  >
                  <md-button
                    @click.stop="table_deleteItem(item)"
                    class="md-just-icon md-round md-danger md-info left-icon"
                    ><md-icon>close</md-icon></md-button
                  >
                </md-table-cell>
              </md-table-row>
              <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
            </md-table>
            <!-- 翻页 -->
            <table-page :total="total" :pageSize="pageSize" v-model="currentPage"/>
          </wizard-tab>

          <wizard-tab >
            <template slot="label"> {{$I18n("p2p_ser")}} </template>
            <md-table v-model="tableData">
              <md-table-row slot="md-table-row" slot-scope="{ item }" >
                <md-table-cell :md-label="$I18n('source_area_type')">{{ item.src_type_name }}</md-table-cell>
                <md-table-cell :md-label="$I18n('the_code')">{{ item.src_area }}</md-table-cell>
                <md-table-cell :md-label="$I18n('name')">{{ item.src_area_name }}</md-table-cell>
                <md-table-cell :md-label="$I18n('object_area_type')">{{ item.dest_type_name }}</md-table-cell>
                <md-table-cell :md-label="$I18n('the_code')">{{ item.dest_area }}</md-table-cell>
                <md-table-cell :md-label="$I18n('name')">{{ item.dest_area_name }}</md-table-cell>
                <md-table-cell :md-label="$I18n('state')">{{ item.state_name }}</md-table-cell>
                <md-table-cell :md-label="$I18n('remarks')">{{ item.remark }}</md-table-cell>

                <md-table-cell :md-label="$I18n('operate')"  class="button-box">
                  <md-button @click.stop="table_editItem(item)" class="md-just-icon md-round md-info">
                    <md-icon>edit</md-icon>
                  </md-button>
                  <md-button @click.stop="table_deleteItem(item)" class="md-just-icon md-round md-danger md-info left-icon">
                    <md-icon>close</md-icon>
                  </md-button>
                </md-table-cell>
              </md-table-row>
              <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
            </md-table>
            <!-- 翻页 -->
            <table-page :total="total" :pageSize="pageSize" v-model="currentPage"/>
          </wizard-tab>
        </simple-wizard>
      </div>
    </div>
    <!-- 弹窗 -->
    <simple-modal ref="modal" :title="modalTitle" :right="openModalType!=='delete'" @submit="modal_submit">
      <template slot="body">
        <!-- 删除弹窗 -->
        <div v-if="openModalType==='delete'">{{$I18n("check_delete", '')}}</div>
        <!-- 修改/添加弹窗 -->
        <div v-else>
          <common-form-item 
            v-for="item in form_modalData" 
            v-model="modalData.Form[item.keys]" 
            :error="modalData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          />
        </div>
      </template>
    </simple-modal>
  </div>
</template>
<script>
import { SimpleWizard, WizardTab } from "@/components";
import { FormClass } from "@/common/tools.js";

export default {
  components: {
    SimpleWizard,
    WizardTab,
  },
  props: ["userinfo_sys"],
  data() {
    return {
      startIndex: 0,
      // 表格相关
      ...({
        searchData : {
          type: 30,
        },
        icon  : "computer",
        title : this.$I18n("user"),
        tableInitData : [], // 表格数据
        // 分页相关
        pageSize : 10,
        currentPage : 1,
        total : 0,
        // 弹窗相关
        openModalType : "upload", // 弹窗类型
        modalTitle : "",  // 弹窗标题
      }),
      // 弹窗表单相关
      modalData : new FormClass({
        src_area : {
          init: "",
          check:"required",
        },
        dest_area : {
          init: "",
          check:"required",
        },
        remark : "",
        src_type : 1,
        dest_type : 2,
        state : 1,
        type: 30,
      }),
      // 弹窗表单报错相关
      // error: {
      //   src_area : false,
      //   dest_area : false,
      // },
      continent : {
        "AF" : this.$I18n("africa"),
        "EU" : this.$I18n("europe"),
        "AS" : this.$I18n("asia"),
        "OA" : this.$I18n("oceania"),
        "NA" : this.$I18n("north_america"),
        "SA" : this.$I18n("latin_america"),
        "AN" : this.$I18n("antarctica"),
      },
    };
  },
  mounted : function() {
    this.api_getPageData();
  },
  watch: {
    currentPage() {
      this.api_getPageData();
    },
    startIndex(newValue){
      if(newValue === 0){ // 30 : 账号服务
        this.searchData.type = 30;
      } else if(newValue === 1){ // 12 : P2P服务
        this.searchData.type = 12;
      }
      this.form_changeSearchData();
    },
  },
  methods: {
    updateIndex(newIndex){
      this.startIndex = newIndex;
    },
    form_changeSearchData(){
      this.searchData = {
        type: this.searchData.type,
        sys : this.userinfo_sys,
      }
      this.currentPage = 1;
      this.api_getPageData();
    },
    table_addItem(){
      this.modalTitle = this.$I18n("add");
      this.modalData.Reset();
      this.openModalType = "add";
      this.$refs.modal.open();
    },
    table_editItem(item){
      this.modalTitle = this.$I18n("edit");
      this.modalData.Update({
        ...item,
      });
      this.openModalType = "edit";
      this.$refs.modal.open();
    },
    table_deleteItem(item){
      this.modalTitle = this.$I18n("delete");
      this.modalData.Update({...item});
      this.openModalType = "delete";
      this.$refs.modal.open();
    },
    // 获取页面信息
    api_getPageData(){
      // 获取角色
      // let page_no = this.currentPage;
      this.$api.getSerZoneBind({
        ...this.searchData,
        sys       : this.userinfo_sys,
        page_size : this.pageSize,
        page_no   : this.currentPage,
      })
        .then(this.$Then(res => {
          this.tableInitData = res.data;
          this.total = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.tableInitData = [];
          this.total = 0;
        }))
    },
    // 隐藏 弹窗
    modal_classicModalHide () {
      this.$refs.modal.close();
    },
    // 提交表单
    modal_submit () {
      if(this.modalData.Check()){
        this.$errorMsg(this.$I18n("pls_input_content"));
        return;
      }
      // let opcode = 1;
      let apiPOST = new Promise(() => {})
      if(this.openModalType === "add"){
        apiPOST = this.$api.addSerZoneBind({
          ...this.modalData.Form,
          sys: this.userinfo_sys,
        })
      } else if (this.openModalType === "edit"){
        apiPOST = this.$api.editSerZoneBind({
          ...this.modalData.Form,
          sys: this.userinfo_sys,
        })
      } else if (this.openModalType === "delete"){
        apiPOST = this.$api.delSerZoneBind({
          ...this.modalData.Form,
        })
      }
      apiPOST
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("succ_num"));
          this.modal_classicModalHide();
          this.api_getPageData();
        }))
        .catch(this.$Catch(this.$I18n("fail_num")))
    },
  },
  computed: {
    form_modalData(){
      return [
        {
          label   : this.$I18n("type"),
          keys    : "type",
          type    : "select",
          options : [
            {
              id  : "30",
              name: this.$I18n('acc_ser'),
            },{
              id  : "12",
              name: this.$I18n('p2p_ser'),
            }
          ],
          hide    : this.openModalType !== 'add'
        },{
          label   : this.$I18n("source_area_type"),
          keys    : "src_type",
          type    : "select",
          options : [
            {
              id  : 1,
              name: this.$I18n('continent'),
            },{
              id  : 2,
              name: this.$I18n('country'),
            }
          ],
          required: true
        },{
          label   : this.$I18n("source_area_code"),
          keys    : "src_area",
          type    : "input",
          check   : true,
          required: true
        },{
          label   : this.$I18n("object_area_type"),
          keys    : "dest_type",
          type    : "select",
          options : [
            {
              id  : 1,
              name: this.$I18n('continent'),
            },{
              id  : 2,
              name: this.$I18n('country'),
            }
          ],
          required: true
        },{
          label   : this.$I18n("object_area_code"),
          keys    : "dest_area",
          type    : "input",
          check   : true,
          required: true
        },{
          label   : this.$I18n("state"),
          keys    : "state",
          type    : "select",
          options : [
            {
              id  : 1,
              name: this.$I18n('is_use'),
            },{
              id  : 2,
              name: this.$I18n('is_not_use'),
            }
          ],
          required: true
        },{
          label   : this.$I18n("remarks"),
          keys    : "remarks",
          type    : "textarea",
        }
      ]
    },
    // 表格数据
    tableData(){
      if (!this.tableInitData || this.tableInitData.length === 0){
        return [];
      } else {
        return [...this.tableInitData]
          // .splice((this.currentPage-1) * this.pageSize, this.pageSize)
          .map(item => {
            let src_type_name  = ""
            switch(item.src_type){
              case 1:
                src_type_name = this.$I18n("continent");
                break
              case 2:
                src_type_name = this.$I18n("country");
                break;
              default:
                src_type_name = this.$I18n("unknow");
                break;
            }

            let dest_type_name = ""
            switch(item.dest_type){
              case 1:
                dest_type_name = this.$I18n("continent");
                break
              case 2:
                dest_type_name = this.$I18n("country");
                break;
              default:
                dest_type_name = this.$I18n("unknow");
                break;
            }
            let src_area_name  = item.src_type == 2 ?this.$I18n(item.src_area) : this.continent[item.src_area]
            if (!src_area_name || src_area_name.indexOf("zh.") > -1 || src_area_name.indexOf("en.") > -1){
              src_area_name = item.src_area
            }
            let dest_area_name = item.dest_type == 2 ?this.$I18n(item.dest_area) : this.continent[item.dest_area]
            if (!dest_area_name || dest_area_name.indexOf("zh.") > -1 || dest_area_name.indexOf("en.") > -1){
              dest_area_name = item.dest_area
            }
            let state_name     = ""
            switch(item.state){
              case 1:
                state_name = this.$I18n("is_use");
                break
              case 2:
                state_name = this.$I18n("is_not_use");
                break;
              default:
                state_name = this.$I18n("is_not_use");
                break;
            }

            return {
              src_type_name,
              dest_type_name,
              src_area_name,
              dest_area_name,
              state_name,
              ... item,
            }
          })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
  .total-page{
    width: 30%;
    display: inline-block;
  }
  .md-card-only-title{
    margin: 0;
    box-shadow: none;
    text-align: left;
    position: relative;
    top: -12px;
    left: -20px;
  }
  .md-card-only-title .title{
    text-align:left !important;
  }
  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  //左侧iocn
  .left-icon{
    margin-left: 16px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
</style>